// src/games/pacman-Antartica/systems/AudioSystem.ts
import {
  AudioSystem as SharedAudioSystem,
  AudioConfig,
} from '../../../engine/ecs/systems/AudioSystem';
import { ResourceManager } from '../../../engine/resources/ResourceManager';

// Antarctica-specific audio configuration
const ANTARCTICA_AUDIO_CONFIG: AudioConfig = {
  // superpowerBackgroundMusic: 'super_power_background.wav', // No longer needed - default matches!
  soundVolume: 0.6,
  musicVolume: 0.4,
  enableSuperpowerMusic: true,
  enableSoundEffects: true,
  enableBackgroundMusic: true,
};

export class AudioSystem extends SharedAudioSystem {
  constructor(resourceManager: ResourceManager) {
    super(resourceManager, ANTARCTICA_AUDIO_CONFIG);
  }
}
